"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _services = require("../../../services");
var _PlanCardHeader = _interopRequireDefault(require("./AirtimePlanCard/PlanCardHeader"));
var _PlanCardInfo = _interopRequireDefault(require("./AirtimePlanCard/PlanCardInfo"));
var _useRecommendationStepper = require("../../../hooks/recommendation/useRecommendationStepper");
var _useRecommendationHandsets = require("../../../hooks/recommendation/useRecommendationHandsets");
var _useRecommendationPlans = require("../../../hooks/recommendation/useRecommendationPlans");
var _useUpsellProducts2 = require("../../../hooks/upsell/useUpsellProducts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var AdditionalAirtimePlans = function AdditionalAirtimePlans(_ref) {
  var plans = _ref.plans;
  var _useRecommendationHan = (0, _useRecommendationHandsets.useRecommendationHandsets)(),
    selectedHandset = _useRecommendationHan.selectedHandset;
  var _useRecommendationPla = (0, _useRecommendationPlans.useRecommendationPlans)(),
    selectedPlan = _useRecommendationPla.selectedPlan;
  var _useUpsellProducts = (0, _useUpsellProducts2.useUpsellProducts)(),
    selectedUpsellProducts = _useUpsellProducts.selectedUpsellProducts;
  var _useRecommendationSte = (0, _useRecommendationStepper.useRecommendationStepper)(),
    onNextStepper = _useRecommendationSte.onNextStepper,
    isLastStep = _useRecommendationSte.isLastStep,
    currentStepObject = _useRecommendationSte.currentStepObject;
  var _useRecommendationPla2 = (0, _useRecommendationPlans.useRecommendationPlans)(),
    onPlanSelect = _useRecommendationPla2.onPlanSelect;
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Container, {
    elevation: true,
    paddingLevel: 4
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.CollapsibleContainer, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.CollapsibleContainerHeader, null, _services.locale.localeString('Recommendation.ShowOtherPlans')), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.CollapsibleContainerBody, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 4
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    columns: {
      sm: 1,
      md: 2
    },
    spacing: 3
  }, plans.map(function (plan, index) {
    return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Container, {
      appearance: "primary",
      state: "incomplete",
      key: index
    }, /*#__PURE__*/_react.default.createElement(_PlanCardHeader.default, {
      plan: plan,
      isAdditionalPlan: true
    }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, null), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.CollapsibleContainer, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.CollapsibleContainerHeader, null, _services.locale.localeString('Recommendation.PlanContainerIncludes')), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.CollapsibleContainerBody, null, /*#__PURE__*/_react.default.createElement(_PlanCardInfo.default, {
      plan: plan,
      isAdditionalPlan: true
    }))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        top: 3
      }
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
      text: "Choose plan",
      width: "full",
      appearance: "primary",
      onClick: function onClick() {
        onPlanSelect(plan.productId);
        !isLastStep && onNextStepper();
        currentStepObject === null || currentStepObject === void 0 ? void 0 : currentStepObject.onNext({
          selectedHandset: selectedHandset,
          selectedPlan: selectedPlan,
          selectedUpsellProducts: selectedUpsellProducts
        });
      }
    })));
  }))))));
};
var _default = AdditionalAirtimePlans;
exports.default = _default;